import { faCheckCircle, faQrcode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'src/components/loader';

const ScanSuccessBanner = ({ isLoading, onScanAnother }) => {
  if (isLoading) {
    return (
      <div className='scan-success-banner scan-success-banner--loading'>
        <Loader inline text='data' />
      </div>
    );
  }

  return (
    <div className='scan-success-banner'>
      <div className='scan-success-banner__header'>
        <FontAwesomeIcon
          icon={faCheckCircle}
          className='scan-success-banner__icon text-success'
          aria-hidden='true'
        />
        <p className='scan-success-banner__text mb-0'>Container scanned successfully</p>
      </div>
      <button
        type='button'
        className='btn btn-primary btn-block d-inline-flex align-items-center justify-content-center fs-mobile-18'
        onClick={onScanAnother}
      >
        <FontAwesomeIcon icon={faQrcode} className='mr-2' aria-hidden='true' />
        Scan another container
      </button>
    </div>
  );
};

ScanSuccessBanner.propTypes = {
  isLoading: PropTypes.bool,
  onScanAnother: PropTypes.func.isRequired,
};

ScanSuccessBanner.defaultProps = {
  isLoading: false,
};

export default ScanSuccessBanner;
